import { notificationJapanese } from "./notification";
import { welcome_tour_ja } from "./welcome-tour";
import { sequence_japanese } from "./sequence/zh-tw";
import base from "./base/ja";
import search from "./search/ja";
import services from "./services/ja";
import intent from "./intent/ja";
import { tableEmptyInformationJapanese } from "./common/table-empty-infomation/zh-tw";
import { globalMessageJapanese } from "./common/global-message/zh-tw";
import { settingApiKeysJapanese } from "./settings/api-keys/zh-tw";
import { settings_pricing_japanese } from "./settings/pricing/zh-tw";
import home from "./home/ja";
import business from "./bussiness/ja";
import filter from "./filter/ja";
import { monitors_ja } from "./monitors";
import { enrich_ja } from "./enrich";
import popup from "./popup/ja";
import { settings_role_team_japanese } from "./settings/role-teams";
import { settings_billing_japanese } from "./settings/billing/zh-tw";
import { settings_pricing_plan_japanese } from "./settings/pricing-plan";
import { settings_profile_organization_ja } from "./settings/profile-organization";
import { settings_users_ja } from "./settings/users";
import { settings_custom_field_japanese } from "./settings/custom-field";
import { settings_redeem_code_ja } from "./settings/redeem-code";
import { settings_plan_usage_ja } from "./settings/plan-usage";
import { settings_referral_ja } from "./settings/referal";

export default {
  //login
  loading: "読み込み中...",
  SignUp: "サインアップ",
  LoginSuccess: "ログインに成功しました",
  LoginOut: "ログアウトに成功しました",
  email: "メールアドレス",
  password: "パスワード",
  logIn: "ログイン",
  WelcomeBack: "おかえりなさい",
  PleaseEnterYourEmailAndPassword:
    "メールアドレスとパスワードを入力してください",
  CharactersRequired: "8文字以上が必要です",
  keepMeSignedIn: "ログインしたままにする",
  forgetPassword: "パスワードを忘れた場合",
  dontHaveAnAccount: "アカウントをお持ちでないですか？",
  signUpNow: "今すぐサインアップ",
  AllRightsReserved: "全著作権所有",
  privacyPolicy: "プライバシーポリシー",
  and: "および",
  termsOfService: "利用規約",
  Name: "名前",
  viewAll: "すべて表示",
  fold: "折りたたむ",
  updateCreditCard: "クレジットカードを更新",
  role: "役割",
  noLimit: "制限なし",
  company: "会社",
  companyName: "会社名",
  signUp: "サインアップ",
  alreadyHaveAnAccount: "すでにアカウントをお持ちですか？",
  getStarted:
    "始めましょう！私たちのプラットフォームでビジネスを強化しましょう",
  signUpSuccess: "サインアップに成功しました",
  noWorries:
    "ご心配なく。登録済みのメールアドレスを入力してください。リセット手順を送信します",
  reset: "リセット",
  forgotPassword: "パスワードを忘れた場合",
  RequestPasswordReset: "パスワードリセットをリクエスト",
  backToLogin: "ログインに戻る",
  verifyPassword: "パスワードを確認",
  EnterANewPasswordFor: "example@gmail.comの新しいパスワードを入力してください",
  ResetPassword: "パスワードをリセット",
  newPassword: "新しいパスワード",
  addCreditCard: "クレジットカードを追加",
  zip: "郵便番号",
  country: "国",
  state: "都道府県",
  city: "市区町村",
  address: "住所",
  billingInformation: "請求情報",
  yourTeams: "チーム",
  cvc: "CVC",
  year: "年",
  month: "月",
  creditCardNumber: "クレジットカード番号",
  cardInformation: "カード情報",
  title: "役職",
  fullName: "フルネーム",
  yourDetail: "詳細",
  creditsToUse: "使用するクレジット。",
  youHave: "所有クレジット",
  download: "ダウンロード",
  buyMoreCredits: "クレジットを追加購入",
  description: "説明",
  topUpCredits: "クレジットをチャージ",
  cancel: "キャンセル",
  date: "日付",
  invoiceHistory: "請求履歴",
  confirmNewPass: "新しいパスワードを確認",
  creditsUsed: "使用済みクレジット",
  newPass: "新しいパスワード",
  oldPass: "古いパスワード",
  cardNumber: "カード番号:",
  changePassword: "パスワードを変更",
  creditUsage: "クレジット使用量",
  typeTheNewTitle: "新しい役職を入力",
  save: "保存",
  addMoreCredits: "クレジットを追加",
  featureRequest: "機能リクエスト",
  creditsMo: "月 {credit} クレジット",
  apiIntegrations: "API連携",
  workspaceSubscription: "ワークスペースサブスクリプション",
  "additional-user-licence": "追加ユーザーライセンス",
  "agency-white-label": "代理店ホワイトラベル",
  "api-extended-limit": "API拡張制限",
  "profile-subscription": "ワークスペースサブスクリプション",
  creditsInYourPlan: "クレジット (プラン内)",
  plugin: "プラグイン",
  settings: "設定",
  phone: "電話番号",
  "1User": "ユーザー1名",
  users: "ユーザー",
  billing: "請求",
  monthlyQueryLimit: "月間クエリ制限",
  price: "価格",
  whatsIncluded: "含まれるもの",
  givenName: "名",
  profile_teams: "プロフィールとチーム",
  purchasePlan: "プランを購入",
  accountOverview: "アカウント概要",
  familyName: "姓",
  dailyQueryLimit: "日次クエリ制限",
  rateLimit: "レート制限",
  youAreOnA: "あなたは",
  PlanAndYourCreditsWillRefreshOn: "プランで、クレジットは に更新されます",
  过期: "",
  searchSettings: "検索設定...",
  plan: "プラン",
  accountInfo: "アカウント情報",
  creditCardInformation: "クレジットカード情報",
  apiUsage: "API使用量",
  mo: "/月",
  perUserPerMonth: "ユーザー1人あたり/月",
  billedAnnually: "年払い",
  dailyQuery: "日次クエリ",
  monthlyQuery: "月次クエリ",
  currentPlan: "現在のプラン",
  everythingInPlus: "プラスのすべての機能を含む",
  addCredits: "クレジットを追加",
  allPlansInclude: "すべてのプランに含まれるもの",
  Amount: "金額",
  credits: "クレジット",
  purchaseSuccess: "クレジットの購入に成功しました。合計クレジットは ",
  Loading: "読み込み中",
  Selected: "選択済み",
  SelectPlan: "プランを選択",
  learnAboutTopupCredits: "クレジットのチャージについて",
  currentPlan: "現在のサブスクリプション",
  upgradeSuccess: "プランの切り替えに成功しました",
  purchaseFailed: "購入に失敗しました",
  upgradeFailed: "プランの切り替えに失敗しました",
  inviteSentSuccessfully: "招待が正常に送信されました",
  DeleteSuccessfully: "正常に削除されました",
  AccountupdatedSuccessfully: "アカウントが正常に更新されました",
  AccountUpdateFailed: "アカウントの更新に失敗しました",
  PasswordUpdatedSuccessfully: "パスワードが正常に更新されました",
  PasswordUpdateFailed: "パスワードの更新に失敗しました",

  teamDetails: "ワークスペース詳細",
  teamName: "ワークスペース名",
  changeTeam: "ワークスペース変更",
  clickToChangeTeam: "クリックしてワークスペースを変更",
  changeTeamSuccessfully: "ワークスペース変更が成功しました",
  status: "ステータス",
  Action: "操作",
  pending: "保留中",
  current: "現在",
  AreYouSureYouWantToDeleteThisTeamMember:
    "このワークスペースメンバーを削除してもよろしいですか？",
  PasswordCannotBeEmpty: "パスワードは必須です",
  newUser: "新規ユーザー",
  deleteUser: "ユーザー削除",
  nickname: "ニックネーム",
  admin: "管理者",
  inviteYourTeam: "ワークスペースメンバーを招待",
  empowerEveryoneToGetMoreDealsDonefaster:
    "全員がより多くの取引を迅速に達成できるように支援",
  addMultipleEmailAddressesSeparatedByCommas:
    "複数のメールアドレスを追加（カンマ区切り）",
  sendInvites: "招待を送信",
  FirstName: "名",
  LastName: "姓",
  timezone: "タイムゾーン",
  contactNo: "連絡先",
  controlYourTeamMembersAndTheirAccountAccessRightHere:
    "ワークスペースメンバーとアカウントアクセス権を管理",
  pleaseEnterYourCurrentPasswordToChangeYourPassword:
    "パスワード変更には現在のパスワードを入力してください",
  updatePassword: "パスワード更新",
  oldPassword: "旧パスワード",
  confirmNewPassword: "新しいパスワード（確認）",
  empowerEveryoneToGetMoreDealsDoneFaster:
    "全員がより迅速に取引を完了できるよう支援",
  enterEmailAddressesMultipleCommaseparated:
    "メールアドレスを入力（複数はカンマ区切り）",
  invoice: "請求書",
  accountAdmin: "アカウント管理者",
  setAsDefault: "デフォルトに設定",
  bankName: "銀行名",
  expiry: "有効期限",
  viewAllYourPreviousInvoicesHere: "これまでの請求書をすべて表示",
  BillingHistory: "請求履歴",
  updateYourCreditCardInformation: "クレジットカード情報を更新",
  ManageCreditCard: "クレジットカード管理",
  CardNumber: "カード番号",
  billingAddress: "請求先住所",
  yourCreditsWillRefreshOn: "クレジット補充予定日",
  plan_prepaid_notice: "{date}まで前払い済み — それまで更新料は請求されません。",
  yourCreditsWillBeChargeOn: "クレジット引落日",
  perYear: "/年",
  perMonth: "/月",
  monthlyCredit: "月間クレジット",
  Usage: "使用量",
  features: "機能",
  credits_mo: "クレジット/月",
  credits_year: "クレジット/年",
  _mo: "/月",
  Quantity: "数量",
  seeOtherPlan: "他のプランを確認",
  subscriptionTiers: "サブスクリプションプラン",
  experiencePricingThatsEasyToUnderstandAndAdaptable:
    "分かりやすく柔軟な料金体系",
  monthlyBilling: "月額課金",
  annualBilling: "年額課金",
  forPlanCustomizationContactOurSalesTeam:
    "プランカスタマイズは営業チームへお問い合わせください",
  billedAnnually_user: "年額課金/ユーザー",
  seePlanComparison: "プラン比較を見る",
  topUp: "チャージ",
  changeTeamNameFailed: "ワークスペース名の変更に失敗しました",

  // purchaseCreditsAtTheRateOf100PerCreditCustomize: 'Purchase credits at the rate of $1.00 per credit. Customize your credit bundle based on your needs. ',
  totalPrice: "合計金額",
  credit: "クレジット",
  collapse: "折りたたむ",
  expand: "展開",
  showNumber: "番号を表示",
  Website: "ウェブサイト",
  b2bTraffic: "B2Bトラフィック",
  b2bReturningVsNew: "B2B再訪問者 vs. 新規訪問者",
  visitors: "訪問者",
  totalView: "総表示回数",
  totalSessions: "総セッション数",
  operatingSystem: "オペレーティングシステム",
  browser: "ブラウザ",
  device: "デバイス",
  companySize: "会社規模",
  topIndustry: "トップ業種",
  topCountries: "トップ国",
  topReferrals: "トップリファラル",
  new: "新規",
  returning: "再訪問",
  countriesStatistics: "国別統計",
  topCompaigns: "トップキャンペーン",
  topPagesByVisits: "訪問数別トップページ",
  topPagesByEngagement: "エンゲージメント別トップページ",
  Referrals: "リファラル",
  Pages: "ページ",
  avgTime: "平均時間",
  totalCompanies: "総会社数",
  b2bPageViews: "B2Bページビュー",
  TotalSessions: "総セッション数",
  viewCompanyList: "会社リストを表示",
  noDiscussionsYet: "まだディスカッションはありません",
  useThisSpaceToAskQuestions:
    "このスペースを使って、質問したり、最新情報を得たり、私たちと直接詳細を話し合ったりできます",
  comingSoon: "近日公開",
  pleaseEnterAValidSiteUrl: "有効なサイトURLを入力してください",
  weAreCurrentlyWorkingOnThisFeature:
    "現在この機能を開発中です。近日中に公開します",
  stayConnectedWithUs:
    "最新情報を受け取るために、ソーシャルメディアチャンネルを通じて私たちとつながり続けてください。",
  selectAWebsite: "ウェブサイトを選択",
  Sequences: "シーケンス",
  label: "ラベル",
  template: "テンプレート",
  folder: "フォルダ",
  single: "シングル",
  group: "グループ",
  steps: "ステップ",
  sizes: "サイズ",
  time: "時間",
  SendATestEmail: "テストメールを送信",
  Categories: "カテゴリー",
  addToCategory: "カテゴリーに追加",
  EnterOrCreateCategories: "カテゴリーを入力または作成",
  addSuccessfully: "正常に追加されました",
  Channels: "チャネル",
  emails: "メール",
  enterChannel: "チャネルを入力",
  CategoryName: "カテゴリー名",
  PleaseEnterANewCategoryName: "新しいカテゴリー名を入力してください:",
  EnterANewCategoryName: "新しいカテゴリー名を入力",
  Steps: "ステップ",
  Actions: "アクション",
  Time: "時間",
  From: "送信元",
  To: "宛先",
  CancelSequenceCreation: "シーケンス作成をキャンセル",
  AreYouSureYouWantToCancelTheSequenceCreationProcess:
    "シーケンス作成プロセスをキャンセルしてもよろしいですか？",
  SaveAsDraft: "下書きとして保存",
  CancelSequence: "シーケンスをキャンセル",
  ByCancelingAllSettingsWillBeLost:
    "キャンセルすると、行ったすべての設定と進捗状況は失われます。",
  ReplyFields: "返信フィールド",
  continue: "続行",
  Contacts: "連絡先",
  Back: "戻る",
  Import: "インポート",
  Imported: "インポート済み",
  Skipped: "スキップ済み",
  Done: "完了",
  NewCustomField: "新しいカスタムフィールド",
  EnterNewLabel: "新しいラベルを入力",
  EnterNewType: "新しいタイプを入力",
  removeRecorded: "録音を削除",
  StayPage: "ページに留まる",
  LeavePage: "ページを離れる",
  NewCategory: "新しいカテゴリー",
  Create: "作成",
  UnlockingSequence: "このシーケンスをロック解除すると、変更が可能になります",
  ModifyingLeadDeselection:
    "このコンテンツを変更すると、現在のテンプレートバージョンが非選択になります",
  Modify: "変更",
  CancelingPreserveCurrent: "キャンセルすると、現在のバージョンが維持されます",
  rename: "名前変更",
  CreatNewLabel: "新しいラベルを作成",
  NewLabel: "新しいラベル",
  PleaseEnterANewLabelName: "新しいラベル名を入力してください:",
  EnterANewLabelName: "新しいラベル名を入力",
  SequenceName: "シーケンス名",
  PleaseProvideNameForNewSequence: "新しいシーケンスの名前を入力してください",
  EnterNewSequenceName: "新しいシーケンス名を入力",
  SetUpEmail: "送信用のメールアカウントを設定",
  NewSchedule: "新しいスケジュール",
  PleaseEnterANewScheduleName: "新しいスケジュール名を入力してください:",
  EnterNewScheduleName: "新しいスケジュール名を入力",
  AddNewTemplate: "新しいテンプレートを追加",
  RemoveFromTemplate: "テンプレートから削除",
  deleteSuccess: "正常に削除されました",
  removeSuccess: "正常に削除されました",
  GroupName: "グループ名",
  PleaseEnterNewGroupName: "新しいグループ名を入力してください",
  EnterNewGroupName: "新しいグループ名を入力",
  TemplateName: "テンプレート名",
  PleaseEnterANewTemplateName: "新しいテンプレート名を入力してください",
  EnterNewTemplateName: "新しいテンプレート名を入力",
  renameSuccessfully: "正常に名前が変更されました",
  CreateSuccessfully: "正常に作成されました",
  addToGroup: "グループに追加",
  SelectChannelForNewTemplate: "新しいテンプレートのチャネルを選択",
  Role: "役割",
  Account: "アカウント",
  customFields: "カスタムフィールド",
  contactsToStartEngagingWithThem:
    "連絡先を追加してエンゲージメントを開始します。",
  thisSequenceDoesntHaveAnyProspectsOrLeadsYetConsid:
    "このシーケンスにはまだ見込み客やリードがありません。連絡先を追加することを検討してください",
  noProspectsAdded: "見込み客が追加されていません",
  deliveryCurrentlyNoMessagesHaveBeenSentThroughTheS:
    "配信。現在、このシーケンスを通じて送信されたメッセージはありません。",
  ensureEfficientCommunicationByMonitoringYourSequen:
    "シーケンスのメッセージを監視して、効率的なコミュニケーションを確保してください",
  noMessagesHaveBeenSent: "メッセージが送信されていません",
  yourNeedsGetStartedByClickingNewSequence:
    "ニーズに合わせて。[+ 新しいシーケンス]をクリックして始めましょう",
  beginBuildingYourSalesStrategiesByDesigningSequenc:
    "ニーズに合わせて設計されたシーケンスを作成して、営業戦略の構築を開始しましょう",
  noSequencesCreatedYet: "まだ作成されたシーケンスはありません",
  leadActions: "リードのアクション",
  leadInformation: "リード情報",
  thisGroupHasNoTemplatesYet: "このグループにはまだテンプレートがありません",
  key: "{expr}",
  copyContent: "コンテンツをコピー",
  default: "デフォルト",
  selectVersion: "バージョンを選択",
  subject: "件名",
  searchTemplatesfolders: "テンプレート/フォルダを検索",
  send: "送信",
  subject2: "件名:",
  enterASubjectOrLeaveItBlankToContinueInTheSameThre:
    "件名を入力するか、空白のままにして同じスレッドで続行します",
  chooseYourChannel: "チャネルを選択",
  kl: "KL",
  addContacts: "連絡先を追加",
  addContactsToSequence: "シーケンスに連絡先を追加",
  addremoveCustomContactField: "カスタム連絡先フィールドを追加/削除",
  contactCustomFields: "カスタム連絡先フィールド",
  type: "タイプ",
  typePhoneNumber: "電話番号を入力",
  addAPhoneNumber: "電話番号を追加",
  fieldType: "フィールドタイプ",
  fieldLabel: "フィールドラベル",
  skipTheFollowingNationalHolidaysLaborDayIndependen:
    "次の祝日をスキップ: 労働者の日、独立記念日、戦没将兵追悼記念日、感謝祭、クリスマスイブ、クリスマス、元日",
  checked: "チェック済み",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi:
    "連絡先に位置情報が含まれている場合、スケジュールのタイムゾーンではなく、連絡先の現地タイムゾーンを使用します。",
  definePostreplyOrMeetingActionAndSequenceCompletio:
    "返信後のアクションまたは会議アクションとシーケンス完了基準を定義",
  stopRepliesHandling: "返信の処理を停止",
  timeZone: "タイムゾーン:",
  country2: "国",
  setMaxInitialEmailsDelaysEnabledisableOpensAndLink:
    "最初のメールの最大数、遅延、開封とリンクの追跡の有効化/無効化を設定",
  configuration: "構成",
  additionalInformation: "追加情報",
  connectALinkedinAccount: "LinkedInアカウントを接続",
  newLinkedinAccount: "新しいLinkedInアカウント",
  feelFreeToRevisitAnyOfThePreviousStepsAtAnyTimeToR:
    "シーケンスを「開始」する前に、いつでも前のステップに戻って情報を確認または更新してください。",
  template2: "テンプレート:",
  next: "次へ",
  settings2: "設定",
  editThisTemplateScheduleFromThe:
    "ここからこのテンプレートのスケジュールを編集",
  typeEmail: "メールの種類",
  templateScheduling: "テンプレートのスケジュール設定",
  launch: "開始",
  linkedin: "LinkedIn",
  addAEmail: "メールを追加",
  addEmailAccount: "メールアカウントを追加",
  addStep: "ステップを追加",
  craftYourCampaign: "キャンペーンを作成",
  tailorYourOwnHoursToSuitSpecificSchedulingNeeds:
    "特定のスケジュール設定のニーズに合わせて、独自の時間を調整します。",
  personalizedScheduling: "パーソナライズされたスケジュール設定",
  requiredInformation: "必須情報",
  chooseEmailAccountsForSendingCampaignMessages:
    "キャンペーンメッセージの送信に使用するメールアカウントを選択",
  accounts: "アカウント",
  enterSequenceName: "シーケンス名を入力",
  thisPageEmpowersYouToTailorYourSchedulingSequenceS:
    "このページでは、好みに合わせてシーケンス設定をカスタマイズできます",
  schedule: "スケジュール",
  useThisOptionToAddContactsToTheSequenceYouHaveCrea:
    "このオプションを使用して、作成したシーケンスに連絡先を追加します。",
  addProspects: "見込み客を追加",
  save2: "保存",
  days: "日",
  days2: "日",
  within: "以内",
  opened: "開封済み",
  day: "日",
  day2: "日",
  waitFor: "待機",
  sendTestEmailToMe: "自分にテストメールを送信",
  create: "作成",
  enterANameForCustomContactField: "カスタム連絡先フィールドの名前を入力",
  a: "A",
  to2: "宛先",
  activated: "有効",
  currentVersion: "現在のバージョン",
  setTheNewVersionDefaultNow: "新しいバージョンを今すぐデフォルトに設定",
  enterNewName: "新しい名前を入力",
  newVersion: "新しいバージョン",
  dontForgetToSetTheNewVersionDefaultOnceYouveFinish:
    "変更が完了したら、新しいバージョンをデフォルトに設定することを忘れないでください。",
  theDeletionOfThisConditionWillAlsoRemoveAllSubsequ:
    "この条件を削除すると、それに続くすべてのステップも削除されます",
  pleaseEnterANewName2: "新しい名前を入力してください:",
  aNewVersionOfTheSequenceHasBeenCreated:
    "シーケンスの新しいバージョンが作成されました。",
  youCanEitherEditTheCurrentVersionOrSaveItAndCreate:
    "現在のバージョンを編集するか、保存して新しいバージョンを作成することができます。",
  areYouSureYouWantToProceed: "続行してもよろしいですか？",
  newVersionName: "新しいバージョン名",
  sequenceStart: "シーケンス開始",
  chooseActions: "アクションを選択",
  chooseSteps: "ステップを選択",
  enterChannel2: "チャネルを入力",
  chooseCategories: "カテゴリーを選択",
  htmlMode: "HTMLモード",
  noResultsFoundForYourSearchCriteria:
    "検索条件に一致する結果が見つかりませんでした",
  fromScratch: "ゼロから始める",
  sender: "送信者",
  finished: "完了",
  inProgress: "進行中",
  fromTemplate: "テンプレートを使用",
  newSequence: "新しいシーケンス",
  nameOwner: "名前所有者",
  sort: "並べ替え",
  filter: "フィルター",
  exportToCSV: "CSVにエクスポート",
  exportRowsCsv:
    "{count} 行を CSV にエクスポートすると {price} クレジットを使用します。 | {count} 行を CSV にエクスポートすると {price} クレジットを使用します。",
  exportSelected: "選択済み",
  exportAllMatching: "一致するすべて",
  exportFields: "含めるフィールド",
  findPeople: "人物を検索",
  ownedBy: "所有者",
  starredOnly: "スター付きのみ",
  starred: "スター付き",
  box2: "ボックス 2",
  box1: "ボックス 1",
  add2: "+ 追加",
  lastSynced: "最終同期日時",
  hourlyLimit: "時間制限",
  dailyLimit: "日次制限",
  account: "アカウント",
  skipTheFollowingNationalHolidaysLaborDayIndependen2:
    "次の祝日をスキップ: 労働者の日、独立記念日、戦没将兵追悼記念日、感謝祭、クリスマスイブ、クリスマス、元日",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi2:
    "連絡先に位置情報が含まれている場合、スケジュールのタイムゾーンではなく、連絡先の現地タイムゾーンを使用します。",
  saveChanges: "変更を保存",
  emailSignature: "メール署名",
  reset2: "リセット",

  pleaseNoteTheValueShouldBe0OrEmails:
    "値は0より大きいか{expr}未満でなければなりません",
  youHaveNoScheduledTemplateYet: "スケジュール済みテンプレートがありません",
  discoverPremiumOptions: "プレミアムオプションを発見",
  mailbox: "メールボックス",
  sendingLimits: "送信制限",
  connect: "接続",
  joinOurCommunityOfPremiumUsersTransformingEmailEng:
    "Pubrioを使用してメールエンゲージメントを変革し、優れた営業成果を達成するプレミアムユーザーコミュニティに参加しましょう",
  enterYourEmailAddress: "メールアドレスを入力",
  toJustMailbox: "{mailNum}メールボックスのみに送信",
  yourCurrentBasicPlanAllowsAccess:
    "現在のベーシックプランでは以下にアクセス可能",
  setAsDefault2: "デフォルトに設定",
  createNewSchedule: "新規スケジュール作成",
  enterTemplateName: "テンプレート名を入力",
  googleMeet: "Google Meet",
  emailPreview: "メールプレビュー",
  addTemplate: "テンプレートを追加",
  simplifyYourWorkflowGroupYourSequenceTemplatesToKe:
    "ワークフローを効率化！シーケンステンプレートをグループ化して整理し、簡単に検索・編集・使用できるようにしましょう",
  startCreatingPersonalizedTemplatesForYourSequences:
    "シーケンス用のパーソナライズドテンプレート作成を開始！「+」ボタンをクリックして新規テンプレートを作成し、スムーズなコミュニケーションを実現",
  noTemplateYet: "テンプレートがありません",
  preview: "プレビュー",
  creatNewGroup: "新規グループ作成",
  creatNewGroup2: "新規グループ作成",
  stayOrganizedWithYourSequenceTemplatesCreateGroups:
    "シーケンステンプレートを整理整頓！グループを作成して簡単に管理・検索でき、編集や使用がより簡単になります",
  noGroupsHaveBeenCreated: "グループが作成されていません",
  creatNewTemplate: "新規テンプレート作成",
  addSequenceTemplateToTheGroup: "グループにシーケンステンプレートを追加",
  byCancelingYouEnsureThatNoChangesAreMade:
    "キャンセルすると変更は保存されません",
  sequenceTemplates: "シーケンステンプレート",
  youCanDeselectAndClickSaveToRemoveTheTemplateFromT:
    "選択を解除して「保存」をクリックすると、グループからテンプレートを削除できます",
  selectTemplateToAddToGroup: "グループに追加するテンプレートを選択",
  sequenceStatus: "シーケンスステータス",
  sequenceStep: "シーケンスステップ",
  newField: "新規フィールド",
  enableTailoredDataEntryAndAdaptationToUniqueBusine:
    "独自のビジネスプロセスに合わせたデータ入力と適応を可能にします",
  customContactFields: "カスタム連絡先フィールド",
  modality: "モダリティ",
  enterADescriptionForCustomContactField:
    "カスタム連絡先フィールドの説明を入力",
  description2: "説明",
  enterADefaultValueForCustomContactField:
    "カスタム連絡先フィールドのデフォルト値を入力",
  defaultValue: "デフォルト値",
  enterAExampleForCustomContactField: "カスタム連絡先フィールドの例を入力",
  example: "例",
  enterPicklistoptionsForCustomContactField:
    "カスタム連絡先フィールドの選択肢を入力",
  newCustomContactFields: "新規カスタム連絡先フィールド",
  engagementMetrics: "エンゲージメントメトリクス",
  message: "メッセージ",
  to3: "宛先：",
  receiver: "受信者",
  claraHan: "クララ・ハン",
  createNewCategory: "新規カテゴリ作成",
  bestRegards: "敬具",
  thanksAgain: "再度感謝申し上げます",
  lookingForwardToAFruitfulCollaborationIfTheresAnyt:
    "実りある協力を楽しみにしております。開始前に解決すべき具体的な事項がございましたら、お知らせください",
  kingLaiAdviser: "キング・ライ（アドバイザー）",
  iAppreciateTheIntroductionToOurMainContacts:
    "主要連絡先のご紹介ありがとうございます：",
  contacted: "連絡済み",
  sendTestEmail: "テストメールを送信",
  thankYouSoMuchForTheWarmWelcomeWereEquallyExcitedA:
    "温かい歓迎に感謝します！Pubrio GTMローンチプロジェクトに参加し、Venture AIチームの一員になれることを同じく楽しみにしています",
  hiJacqueline: "ジャクリーン様",
  nov152023118Pm: "2023年11月15日 13:18",
  message2: "{total_messages}件のメッセージ",
  topEcommerceAutomationPlatf:
    "トップクラスのEコマース自動化プラットフォーム...",
  cindyHsu: "シンディー・シュー",
  includeSignature: "署名を含める",
  ch: "CH",
  continueOnFail: "失敗時も継続",
  welcomeToPubrioGtm: "Pubrio GTMへようこそ",
  replyToPreviousThread: "前のスレッドに返信",
  sendAutomatic: "自動送信 {title}",
  searchByContacts: "連絡先で検索",
  processingErrorOccurredMaximumNumberOfUniqueContac:
    "処理エラー：月間ユニーク連絡先の最大数に達しました",
  oct140954Pm: "10月14日 21:54",
  shiftdragToMoveTheCanvas: "Shift+ドラッグでキャンバスを移動",
  active: "アクティブ",
  inactive: "非アクティブ",
  archived: "アーカイブ済み",
  archive: "アーカイブ",
  unarchive: "アーカイブ解除",
  archivedSuccessfully: "アーカイブに成功しました",
  unarchivedSuccessfully: "アーカイブ解除に成功しました",
  sequenceArchivedSuccess: "シーケンスのアーカイブに成功",
  sequenceUnarchivedSuccess: "シーケンスのアーカイブ解除に成功",
  alphabetical: "アルファベット順",
  creationDate: "作成日",
  viewDate: "表示日",
  staredFirst: "スター付きを先頭に",
  SaveAsANewVersion: "新規バージョンとして保存",
  SaveCurrentVersion: "現在のバージョンを保存",
  schedules: "スケジュール",
  EmailsSentPerDay: "1日あたりの送信メール数",
  EmailsSentPerHour: "1時間あたりの送信メール数",
  DelayBetweenEachEmailSent: "メール送信間隔（秒）",
  RecommendedDailyLimit:
    "推奨日次制限：50-100通（高度にパーソナライズされたキャンペーンを送信し、ドメイン評判を維持している場合のみ100通を超えることが可能）",
  RecommendedHourlyLimit:
    "推奨時間制限：1時間あたり100通未満。120通を超えないでください",
  currentDelayAllows: "現在の遅延設定では1時間あたり最大120通の送信が可能です",
  SetasDefault: "デフォルトに設定",
  monday: "月曜日",
  tuesday: "火曜日",
  wednesday: "水曜日",
  thursday: "木曜日",
  friday: "金曜日",
  saturday: "土曜日",
  sunday: "日曜日",
  Templates: "テンプレート",
  Analytics: "分析",
  Meetings: "会議",
  Settings: "設定",
  EnterTemplateName: "テンプレート名を入力",
  EnterGroupName: "グループ名を入力",
  ExportAllData: "全データをエクスポート",
  ExportAsCSV: "CSV形式でエクスポート",
  Total: "合計",
  Opened: "開封済み",
  Clicked: "クリック済み",
  NotOpened: "未開封",
  Bounced: "バウンス",
  Replied: "返信済み",
  Failed: "失敗",
  Inbox: "受信トレイ",
  Report: "レポート",
  Log: "ログ",
  UseThisTemplate: "このテンプレートを使用",
  UseThisFolder: "このフォルダを使用",
  UpdateThisTemplate: "このテンプレートを更新",
  RemoveFromGroup: "グループから削除",
  DeleteThisTemplate: "このテンプレートを削除",
  MarkAsFinished: "完了としてマーク",
  Remove: "削除",
  Pause: "一時停止",
  Resume: "再開",
  AddToSequence: "シーケンスに追加",
  Export: "エクスポート",
  InProgress: "進行中",
  Finished: "完了",
  Paused: "一時停止中",
  Engaged: "エンゲージ中",
  Reply: "返信",
  NotSent: "未送信",
  MaxNumberOfEmailsPerDay: "1日あたりの最大メール数",
  MaxNumberOfEmailsPerHour: "1時間あたりの最大メール数",
  EnableOpensTracking: "開封追跡を有効化",
  EnableReplyTracking: "返信追跡を有効化",
  EnableClickTracking: "クリック追跡を有効化",
  ReplyByMessage: "メッセージで返信",
  BookAMeeting: "会議を予約",
  ClickOnLink: "リンクをクリック",
  CreateManually: "手動で作成",
  AddContactsToTheSequenceManually: "連絡先を手動でシーケンスに追加（1件ずつ）",
  ImportFromCSV: "CSVからインポート",
  UploadCSVFileToAddContactsToSequence:
    "CSVファイルをアップロードして連絡先をシーケンスに追加",
  AddFromExisting: "既存から追加",
  AddExistingContactsIntoTheSequence: "既存の連絡先をシーケンスに追加",
  ChooseFile: "ファイルを選択",
  MapAttributes: "属性をマッピング",
  Options: "オプション",
  ReviewAndImport: "確認してインポート",
  UpdateMissingFields: "不足フィールドを更新",
  DetectContactTimeZoneAutomatically: "連絡先のタイムゾーンを自動検出",
  account_website: "アカウントウェブサイト",
  linkedin_url: "LinkedIn URL",
  raw_address: "生の住所",
  first_name: "名",
  last_name: "姓",
  account_name: "アカウント名",
  Identifier: "識別子",
  firstName: "名",
  lastName: "姓",
  EnterJobTitleOrPosition: "職種または役職を入力",
  EnterCompanyName: "会社名を入力",
  EnterYourCustomerID: "顧客IDを入力",
  EnterCompanyWebsiteURL: "会社ウェブサイトURLを入力",
  EnterLinkedInProfileURL: "LinkedInプロフィールURLを入力",
  EnterCity: "都市名を入力",
  versionName: "バージョン名",
  PleaseEnterANewVersionName: "新しいバージョン名を入力してください",
  EnterNewVersionName: "新しいバージョン名を入力",
  versions: "バージョン",
  SequenceNameUpdatedSuccessfully: "シーケンス名の更新に成功しました",
  SequenceNameCannotBeEmpty: "シーケンス名は必須です",
  delete_success: "削除に成功しました",
  delete_fail: "削除に失敗しました",
  set_default_success: "デフォルト設定に成功しました",
  DuplicateVersionSuccessfully: "バージョンの複製に成功しました",
  UpdateSuccessfully: "更新に成功しました",
  AddToGroupSuccessfully: "グループへの追加に成功しました",
  sendAutomaticEmail: "自動メールを送信",
  sendMessage: "メッセージを送信",
  uploadFailed: "アップロードに失敗しました",
  InvalidEmailFormat: "無効なメール形式",
  FailedToSetUpEmailAccount: "メールアカウントの設定に失敗しました",
  noAccount: "アカウントがありません",
  addAnAccountToPersonalizYourExperienceAndUnlock:
    "アカウントを追加してエクスペリエンスをパーソナライズし、プレミアム機能を解除",
  trackingFeaturesForThisSequence: "このシーケンスの追跡機能",
  UpdatedSuccessfully: "更新に成功しました",
  update_fail: "更新に失敗しました",
  connectYourGoogleMeetAccountToPubrioConversations:
    "Google MeetアカウントをPubrio会話に接続",
  set_default_fail: "デフォルト設定に失敗しました",
  duplicatedSuccessfully: "複製に成功しました",
  noStepsInSequencePleaseAddStepsFirst:
    "シーケンスにステップがありません。まずステップを追加してください",
  addLabelSuccessfully: "ラベルの追加に成功しました",
  PleaseEnterSequenceName: "シーケンス名を入力してください",
  sequenceNameCannotBeEmpty: "シーケンス名は必須です",
  sequenceNameUpdatedSuccessfully: "シーケンス名の更新に成功しました",
  createStepFlowSuccessfully: "ステップフローの作成に成功しました",
  updateStepFlowSuccessfully: "ステップフローの更新に成功しました",
  testEmailSentSuccessfully: "テストメールの送信に成功しました",
  removeEmailAccountSuccessfully: "メールアカウントの削除に成功しました",
  pleaseSelectTheDataToBeExported: "エクスポートするデータを選択してください",
  confirm: "確認",
  saveFailed: "保存に失敗しました",
  deleteThisStep: "このステップを削除",
  Email: "メール",
  LinkedIn: "LinkedIn",
  API: "API",
  Task: "タスク",
  Custom: "カスタム",
  proceedImmediately: "すぐに進む",
  dayss: "日",
  hourss: "時間",
  minutess: "分",
  theConditionAndAllTheStepsThatFollowFromItWillBeDeleted:
    "この条件とそれに続くすべてのステップが削除されます。続行しますか？",
  sendConnectionRequest: "接続リクエストを送信",
  viewProfile: "プロフィールを表示",
  callAnAPI: "APIを呼び出す",
  createAManualTask: "手動タスクを作成",
  hasEmailAddress: "メールアドレスを持っている",
  hasLinkedInURL: "LinkedIn URLを持っている",
  hasPhoneNumber: "電話番号を持っている",
  customCondition: "カスタム条件",
  openedEmail: "メールを開封した",
  clickOnLinkInEmail: "メール内のリンクをクリックした",
  unsubscribeFromEmail: "メールの配信停止",
  bookAMeeting: "会議を予約",
  acceptedInvite: "招待を受諾",
  conditions: "条件",
  Yes: "はい",
  No: "いいえ",
  newVariable: "新しい変数",
  selectVariable: "変数を選択",
  ifLeadVariable: "リード変数が",
  condition: "条件",
  selectCondition: "条件を選択",
  contains: "を含む",
  is_equal_to: "と等しい",
  is_empty: "が空である",
  is_not_empty: "が空でない",
  picture: "画像",
  company_domain: "会社ドメイン",
  company_name: "会社名",
  icebreaker: "アイスブレーカー",
  change_steps_conditions: "ステップ/条件を変更",
  ForceASpecificSenderForThisStep: "このステップに特定の送信者を強制する",
  method: "方法",
  selectASender: "送信者を選択",
  assignAPITaskTo: "APIタスクを割り当て",
  enterCompanyNamesAndPressEnterKey:
    "会社名を入力してEnterキーを押してください",
  feelFreeToEditTheContentAndSaveYourChangesDirectly:
    "コンテンツを自由に編集し、変更を直接保存してください",
  permission: "権限",
  addAnyAdditionalStepsOrConditionsAsNeeded:
    "必要に応じて追加のステップや条件を追加",
  reviewAndFinalizeSequenceSettingsAndPreferences:
    "シーケンス設定とプリファレンスを確認して確定",
  // setting
  nameOnCard: "カード名義",
  expiryDate: "有効期限",
  cvccvv: "CVC/CVV",
  details: "詳細",
  notification: "通知",
  markAsAllRead: "すべて既読にする",
  Personal: "個人",
  profile: "プロフィール",
  extensions: "拡張機能",
  notifications: "通知",
  Company: "会社",
  roles: "役割",
  teams: "チーム",
  "current-usage": "プランと使用状況",
  "upgrade-plan": "プランをアップグレード",
  Products: "製品",
  APIKeys: "APIキー",
  popular: "人気",
  priceSequence: "シーケンス (近日公開)",
  free: "無料",
  lite: "Lite",
  growth: "Growth",
  business: "Business",
  enterEmailAddressesMultipleCommaSeparated:
    "メールアドレスを入力 [複数、コンマ区切り]",
  sharingRulesSelectTeamToEnableThisField:
    "共有ルール[このフィールドを有効にするチームを選択]",
  allSeatsAreCurrentlyOccupiedAnyNewUsersNeedingAPaidSeatWillIncurAdditionalCharges:
    "すべての席が現在占有されています。有料席が必要な新しいユーザーには追加料金が発生します。",
  additionalUserLicence: "追加ユーザーライセンス",
  costPerBillingCycle: "合計費用 (請求サイクル)",
  "select...": "選択...",
  invite: "招待",
  services: "サービス",
  "services-group": "サービスグループ",
  "all-notification-services": "すべての通知サービス",
  "services-status-update": "サービスステータス更新",
  "system-group": "システムグループ",
  "all-notification-system": "すべての通知システム",
  "system-new-feature-release": "システム新機能リリース",
  "system-news-letter": "システムニュースレター",
  "system-generic-alarm": "システム汎用アラーム",
  markAsRead: "既読にする",
  showMore: "もっと見る",
  changedStatusTo: "ステータスが変更されました:",
  "access-management-group": "アクセス管理グループ",
  "access-management-roles": "アクセス管理の役割",
  "access-management-create-roles": "アクセス管理の役割作成",
  "access-management-edit-user-roles": "アクセス管理のユーザー役割編集",
  "access-management-add-role-to-users": "アクセス管理のユーザーへの役割追加",
  "access-management-delete-users-role": "アクセス管理のユーザー役割削除",
  "access-management-delete-roles": "アクセス管理の役割削除",
  "access-management-read-roles-and-role-users":
    "アクセス管理の役割と役割ユーザーの読み取り",
  "access-management-teams": "アクセス管理のチーム",
  "access-management-delete-users-team": "アクセス管理のユーザーチーム削除",
  "access-management-read-teams-sharing-rules-teams-users":
    "アクセス管理のチーム、共有ルール、チームユーザーの読み取り",
  "access-management-create-teams": "アクセス管理のチーム作成",
  "access-management-edit-teams-sharing-rules":
    "アクセス管理のチーム共有ルール編集",
  "access-management-delete-teams-sharing-rules":
    "アクセス管理のチーム共有ルール削除",
  "access-management-add-and-update-team-to-users":
    "アクセス管理のユーザーへのチーム追加と更新",
  "access-management-read-team-relations":
    "アクセス管理のチーム関連性の読み取り",
  "access-management-modify-team-relations": "アクセス管理のチーム関連性の変更",
  "intent-signal-group": "インテントシグナルグループ",
  "market-intent-signal": "マーケットインテントシグナル",
  "web-intent-signal": "ウェブインテントシグナル",
  "web-intent-signal-add-and-activate":
    "ウェブインテントシグナルの追加と有効化",
  "web-intent-signal-read-data": "ウェブインテントシグナルデータの読み取り",
  "web-intent-signal-export-data":
    "ウェブインテントシグナルデータのエクスポート",
  "web-intent-signal-delete-data": "ウェブインテントシグナルデータの削除",
  "web-intent-signal-read-analytic": "ウェブインテントシグナル分析の読み取り",
  "search-group": "検索グループ",
  "company-search": "会社検索",
  "prospects-search": "見込み客検索",
  "sequence-group": "シーケンスグループ",
  sequences: "シーケンス",
  "service-create-request": "サービス作成リクエスト",
  "service-update-request": "サービス更新リクエスト",
  "service-read-request": "サービス読み取りリクエスト",
  "service-delete-service-attachment": "サービス添付ファイルの削除",
  "service-delete-service-message": "サービスメッセージの削除",
  "service-send-and-edit-service-message": "サービスメッセージの送信と編集",
  "service-upload-service-attachment": "サービス添付ファイルのアップロード",
  "settings-group": "設定グループ",
  "custom-fields": "カスタムフィールド",
  "user-management-and-billing-group": "ユーザー管理と請求グループ",
  "billing-read-credit-card": "請求のクレジットカードの読み取り",
  "billing-download-invoice": "請求書のダウンロード",
  "billing-read-invoice": "請求書の読み取り",
  "credit-usage": "クレジット使用状況",
  "credit-usage-read-profile-detail":
    "クレジット使用状況のプロフィール詳細の読み取り",
  "credit-usage-read-profile-usage":
    "クレジット使用状況のプロフィール使用状況の読み取り",
  "profile-and-team": "プロフィールとチーム",
  "profile-and-team-invite-team-member":
    "プロフィールとチームのチームメンバー招待",
  "profile-and-team-update-profile": "プロフィールとチームのプロフィール更新",
  "profile-and-team-delete-team-member":
    "プロフィールとチームのチームメンバー削除",
  "profile-and-team-get-user-secret-token":
    "プロフィールとチームのユーザーシークレットトークンの取得",
  "profile-and-team-update-user-and-password":
    "プロフィールとチームのユーザーとパスワードの更新",
  "profile-and-team-read-profile-users":
    "プロフィールとチームのプロフィールユーザーの読み取り",
  "upgrade-plan-read-subscription":
    "プランアップグレードのサブスクリプションの読み取り",
  "upgrade-plan-upgrade-subscription":
    "プランアップグレードのサブスクリプションのアップグレード",
  "all-access-access-management-roles": "全アクセス権 アクセス管理の役割",
  "all-access-access-management-teams": "全アクセス権 アクセス管理のチーム",
  "all-access-market-intent-signal-page":
    "全アクセス権 マーケットインテントシグナルページ",
  "all-access-web-intent-signal-page":
    "全アクセス権 ウェブインテントシグナルページ",
  "all-access-company-search-page": "全アクセス権 会社検索ページ",
  "all-access-prospects-search-page": "全アクセス権 見込み客検索ページ",
  "all-access-sequence-page": "全アクセス権 シーケンスページ",
  "all-access-service-page": "全アクセス権 サービスページ",
  "all-access-custom-fields-page": "全アクセス権 カスタムフィールドページ",
  "all-access-billing-page": "全アクセス権 請求ページ",
  "all-access-credit-usage-page": "全アクセス権 クレジット使用状況ページ",
  "all-access-profile-and-team-page": "全アクセス権 プロフィールとチームページ",
  newPermissionProfile: "新しい権限プロフィール",
  enterAName: "名前を入力",
  addUserToRole: "ユーザーを役割に追加",
  changePermission: "権限を変更",
  selectPermissionProfiles: "権限プロフィールを選択",
  backToRoles: "役割に戻る",
  updateRole: "役割を更新",
  enterADescription: "説明を入力",
  createANewRole: "新しい役割を作成",
  remove_role_title: "ユーザーから役割を削除しますか？",
  remove_team_title: "チームからユーザーを削除しますか？",
  AreYouSureYouWantToRemoveThisRole: "この役割を削除してもよろしいですか？",
  AreYouSureYouWantToRemoveThisUserFromTheTeam:
    "チームからこのユーザーを削除してもよろしいですか？",
  ProceedingWithDeletionWillPermanentlyRemoveTheRoleFromTheUser:
    "ユーザーは、それに関連付けられたすべての権限へのアクセス権を直ちに失います。",
  ProceedingWithDeletionWillPermanentlyRemoveTheUserFromTheTeam:
    "そのユーザーは、チームによって管理されている共有リソース、割り当て、または共有ルールへのアクセス権を失う可能性があります。",
  relation: "関連性",
  newTeam: "新しいチーム",
  "full-sharing-market-intent-signal-data":
    "マーケットインテントシグナルデータの完全共有",
  "full-sharing-web-intent-signal-data":
    "ウェブインテントシグナルデータの完全共有",
  "full-sharing-company-search-data": "会社検索データの完全共有",
  "full-sharing-prospects-search-data": "見込み客検索データの完全共有",
  "full-sharing-sequence-data": "シーケンスデータの完全共有",
  "full-sharing-service-data": "サービスデータの完全共有",
  "share-service-attachments": "サービス添付ファイルを共有",
  "share-service-messages": "サービスメッセージを共有",
  RenameSharingRules: "共有ルールの名前を変更",
  enterNewSharingRulesNameBelow: "新しい共有ルール名を以下に入力してください:",
  enterNewSharingRulesName: "新しい共有ルール名を入力",
  enterNewSharingRulesDescriptionBelow:
    "新しい共有ルールの説明を以下に入力してください:",
  enterNewSharingRulesDescription: "新しい共有ルールの説明を入力",
  enterSharingRulesName: "共有ルール名を入力",
  currentUsers: "現在のユーザー",
  pendingUsers: "保留中のユーザー",
  addRole: "役割を追加",
  addTeam: "チームを追加",
  addPermission: "権限を追加",
  "Re-invite": "再招待",
  relations: "関連性",
  "is-parent-of": "の親です",
  addRelation: "関連性を追加",
  deleteRelation: "関連性を削除",
  updateRelation: "関連性を更新",
  API_Keys: "APIキー",
  createNewKey: "新しいキーを作成",
  createAPIKey: "APIキーを作成",
  APIs: "API",
  setAsMasterKey: "マスターキーとして設定",
  "growth-annual": "Growth-年間",
  business: "Business",
  "website-intent-data": "ウェブサイトインテントデータ",
  "demo-identification": "デモ識別",
  activateTheNewVersionNow: "新しいバージョンを今すぐ有効にする",
  feedbackSendSuccessfully: "フィードバックの送信に成功しました",
  feedbackSendFailed: "フィードバックの送信に失敗しました",
  autoSave: "自動保存",
  serviceDescShowMore: "もっと見る",
  serviceDescShowLess: "少なく表示",
  members: "メンバー",
  shareTo: "共有先...",
  findTeamMembers: "チームメンバーを見つける",
  select: "選択",
  whenBalanceFallsBelow: "残高が以下を下回った場合",
  automaticallyTopUp: "自動的にチャージ",
  autoTopupWillAutomaticallyChargeYourPaymentMethodT:
    "自動チャージは、お客様の支払い方法に自動的に請求します。無効にするには、このチェックボックスをオフにしてください",
  enableAutoTopups: "自動チャージを有効にする",
  validThru: "有効期限",
  currentBalance: "現在の残高",
  cardHolder: "カード名義人",
  gotIt: "了解",
  pleaseEnsureYourPaymentMethodIsUptodateAndThatYouA:
    "有効にする前に、お支払い方法が最新であることを確認し、この自動プロセスに同意していることをご確認ください。",
  thresholdCredits: "しきい値: {creditLimit} クレジット",
  creditAmountCredits: "クレジット額: {choosedTopUpCredit} クレジット",
  enablingAutoTopupsWillAutomaticallyAddCreditsToYou:
    "自動チャージを有効にすると、残高が指定されたしきい値を下回ったときに、アカウントにクレジットが自動的に追加されます。これにより、選択したお支払い方法に自動的に請求が行われる場合があります。",
  thisWillAutomaticallyAddCreditsToYourAccountWhenev:
    "残高が {creditLimit} クレジットを下回るたびに、アカウントに {choosedTopUpCredit} クレジットが自動的に追加されます",
  autoTopupNotice: "自動チャージ通知",
  roleName: "役割名",
  addUser: "ユーザーを追加",
  newRole: "新しい役割",
  userName: "ユーザー名",
  joined: "参加日",
  thisRoleCurrentlyHasNoUsersAssignedToItStartAddingTeamMembersToDefineTheirResponsibilitiesAndStreamlineYourWorkflow:
    "この役割には現在、ユーザーが割り当てられていません。チームメンバーを追加して、その責任を定義し、ワークフローを合理化してください。",
  noUsersAssigned: "ユーザーが割り当てられていません",

  addUserToTeam: "チームにユーザーを追加",
  user: "ユーザー",
  sharingRuleGroup: "共有ルールグループ",
  updateTeam: "チームを更新",
  createANewTeam: "新規チーム作成",
  backToTeams: "チームに戻る",
  listOfSharingRules: "共有ルール一覧",
  sharingRules: "共有ルール",
  manageSharingRules: "共有ルール管理",
  CreateAndCustomizeSharingRulesToControlAccessForDifferentUsersClickTheButtonBelowToAddNewSharingRules:
    "異なるユーザーのアクセス制御のため共有ルールを作成・カスタマイズします。下のボタンで新規共有ルールを追加できます。",
  newSharingRules: "新規共有ルール",

  // 価格設定
  exportLimit: "エクスポート上限",
  customRolePermission: "カスタムロール権限",
  teamManagement: "チーム管理",
  API: "API",
  linkedinAccount: "LinkedInアカウント",
  perPageLimit: "ページ当たり上限",
  recordUploadLimit: "レコードアップロード上限",
  creditRollover: "クレジット繰越",
  quotaSharing: "クォータ共有",
  quotaAdjustment: "クォータ調整",
  add_On: "アドオン",
  topUpCredits: "クレジットチャージ",
  webVisitorIdentification: "ウェブ訪問者識別",
  dataExportCredit: "データエクスポート",
  companySearchCredit: "企業検索",
  peopleSearchCredit: "リード検索",
  emailRedeemCredit: "メール検索",
  phoneNumberRedeemCredit: "電話番号検索",
  recordSelection: "レコード選択",
  portal: "ポータル",
  queryLimitPerHour: "1時間当たりクエリ上限",
  queryLimitPerDay: "1日当たりクエリ上限",
  callLimitPerHour: "1時間当たりコール上限",
  callLimitPerDay: "1日当たりコール上限",
  callLimitPerMonth: "1ヶ月当たりコール上限",
  basicSequencing: "基本シーケンス",
  numberOfSequences: "シーケンス数",
  numberOfMailboxesPerUser: "ユーザー当たりメールボックス数",
  numberOfLinkedinAccountPerUser: "ユーザー当たりLinkedInアカウント数",
  numberOfSlackAccountPerUser: "ユーザー当たりSlackアカウント数",
  automatedFollowUp: "自動フォローアップ",
  advancedSequencing: "高度なシーケンス",
  abTesting: "A/Bテスト",
  multipleEmailTemplates: "複数メールテンプレート",
  reporting: "レポート",
  emailOpenTracking: "メール開封トラッキング",
  emailClickTracking: "メールクリックトラッキング",
  emailReplyTracking: "メール返信トラッキング",
  support: "サポート",
  priorityEmailSupport: "優先メールサポート",
  companySelectionLimit: "企業選択上限",
  prospectSelectionLimit: "リード選択上限",
  totalPageLimit: "総ページ上限",
  pricingYear: "年",
  "growth-annual": "スタンダードプラン",
  "business-annual": "ビジネスプラン",
  pricingSearch: "検索",
  pricingSearches: "検索回数",
  pricingMonth: "月",
  topupCredit: "クレジットチャージ",
  perUserPerYear: "ユーザー毎/月\n年間課金",
  perUserPerMonth: "ユーザー毎/月\n月間課金",
  customCredits: "カスタムクレジット",
  customSearches: "カスタム検索",
  queryLimitPerMonth: "1ヶ月当たりクエリ上限",
  customized: "カスタマイズ",
  custom: "カスタム",
  free: "無料プラン",
  growth: "スタンダードプラン",
  business: "ビジネスプラン",
  organization: "カスタムプラン",
  search: "データ検索",

  // 設定
  pleaseSelectTheUserYouWantToAdd: "追加するユーザーを選択してください",
  pleaseSelectTheUserYouWantToDelete: "削除するユーザーを選択してください",
  pleaseSelectTheUserYouWantToAddPermission:
    "権限を追加するユーザーを選択してください",

  range_separator: "～",
  start_placeholder: "開始日",
  end_placeholder: "終了日",
  redirectSoon: "リダイレクトします",
  top_up_credits_dialog_tip:
    "クレジットあたり${0}のレートで購入。ニーズに合わせてクレジットバンドルをカスタマイズできます。",
  auto_top_up_notice_title: "自動チャージ通知",
  not_now: "後で",
  auto_top_up_para_1:
    "自動チャージを有効にすると、残高が設定金額を下回った際に自動的にクレジットが追加されます。",
  auto_top_up_para_2: "選択した支払い方法から料金が請求されます。",
  activate: "有効化",
  assign: "割り当て",
  ...sequence_japanese,
  ...notificationJapanese,

  ...base,
  ...search,
  ...services,
  ...intent,
  ...tableEmptyInformationJapanese,
  ...globalMessageJapanese,
  ...settingApiKeysJapanese,
  ...settings_pricing_japanese,
  ...home,
  ...business,
  ...filter,
  ...popup,
  ...settings_role_team_japanese,
  ...settings_pricing_plan_japanese,
  ...settings_billing_japanese,
  ...settings_profile_organization_ja,
  ...settings_users_ja,
  ...settings_custom_field_japanese,
  ...settings_redeem_code_ja,
  ...settings_plan_usage_ja,
  ...settings_referral_ja,
  ...monitors_ja,
  ...enrich_ja,
  ...welcome_tour_ja,
};
